import { render } from "./2AHealthyOcean.vue?vue&type=template&id=1e6f7db6"
import script from "./2AHealthyOcean.vue?vue&type=script&lang=js"
export * from "./2AHealthyOcean.vue?vue&type=script&lang=js"
script.render = render

export default script